(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alp-announcebar-flash"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-flash-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-flash-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-flash-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-flash-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // close alp-announcebar-flash-close-btn
    document.querySelectorAll('.alp-announcebar-flash-close-btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        btn.parentElement.style.display = 'none';
      });
    });
    // get height
    AlpFn.GetTheHeight('.alp-announcement-bar-flash-section', 'flash-bar');
    setInterval(() => {
      AlpFn.GetTheHeight('.alp-announcement-bar-flash-section', 'flash-bar');
    }, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-announcebar-new"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // init alp-announcebar-new-slider-1-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-1-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-2-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-2-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
    // init alp-announcebar-new-slider-3-swiper swiper vertical
    new Swiper('.alp-announcebar-new-slider-3-swiper', {
      //   direction: 'vertical',
      rewind: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      speed: 600,
      effect: 'creative',
      creativeEffect: {
        prev: {
          opacity: 0,
          origin: 'top center',
          translate: [0, 0, 0],
          rotate: [100, 0, 0],
        },
        next: {
          opacity: 0,
          origin: 'bottom center',
          translate: [0, 0, 0],
          rotate: [-100, 0, 0],
        },
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-bfcm-subscribe-form"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const triggerFormId = document.querySelectorAll('[data-trigger-form-id]');
    triggerFormId.forEach((item) => {
      item.addEventListener('click', () => {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', item.getAttribute('data-trigger-form-id')]);
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-combo-sale-list-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // alp-combo-sale-list-item-gifts-content active product
    $('.alp-combo-sale-list-item-gifts-content > div').click(function () {
      let $this = $(this);
      $this.addClass('active').siblings().removeClass('active');
      //
      let $price = $this.attr('data-price');
      let $product_price = $this.attr('data-product-price');
      $('.alp-combo-sale-list-item-gifts-price').find('span.final-price').text($price);
      $('.alp-combo-sale-list-item-gifts-price').find('span.original-price-value').text($product_price);
      //
      let $coupon_code = $this.attr('data-coupon-code');
      navigator.clipboard
        .writeText($coupon_code)
        .then(() => {
          const notification = $this.find('.copyNotification');
          notification.stop().slideDown(300);
          setTimeout(() => {
            notification.stop().slideUp(200);
          }, 5000);
        })
        .catch((err) => {});
    });
    //
    $('.combo-add-to-cart-button').on('click', async function () {
      let $this = $(this);
      let $parent = $this.parents('.alp-combo-sale-list-item');
      let variants = '';
      $parent.find('[data-active-variant].active').each(function () {
        variants += $(this).attr('data-active-variant') + ',';
      });
      variants = variants.slice(0, -1);
      $this.addClass('adding');
      await AlpFn.AddToCartOne(variants, 1);
      await AlpFn.refreshCart('[data-ajax-cart]');
      $this.removeClass('adding');
      document.body.classList.add('cart-open');
      setTimeout(() => {
        $('[data-ajax-cart]').addClass('open');
        document.body.classList.add('noscroll');
      }, 50);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-combo-sale-list"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    //
    $('.combo-add-to-cart-button').on('click', async function () {
      let $this = $(this);
      let $parent = $this.parents('.alp-combo-sale-list-item');
      let variants = '';
      $parent.find('[data-active-variant]').each(function () {
        variants += $(this).attr('data-active-variant') + ',';
      });
      variants = variants.slice(0, -1);
      $this.addClass('adding');
      await AlpFn.AddToCartOne(variants, 1);
      await AlpFn.refreshCart('[data-ajax-cart]');
      $this.removeClass('adding');
      document.body.classList.add('cart-open');
      setTimeout(() => {
        $('[data-ajax-cart]').addClass('open');
        document.body.classList.add('noscroll');
      }, 50);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-combo-sale-select-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // popup open
    $('.alp-combo-sale-select-product-main-trigger').click(function () {
      let $this = $(this);
      let $popup = $this.parents('.alp-section').find('.alp-combo-sale-select-product-main-selector-popup');
      $popup.addClass('active');
    });
    // popup close
    $(
      '.alp-combo-sale-select-product-main-selector-inner-header-close, .alp-combo-sale-select-product-main-selector-popup-bg'
    ).click(function () {
      let $this = $(this);
      let $popup = $this.parents('.alp-combo-sale-select-product-main-selector-popup');
      $popup.removeClass('active');
    });
    //
    $('.alp-product-item-xx-selector-add').click(function () {
      let $this = $(this);
      let $popup = $this.parents('.alp-combo-sale-select-product-main-selector-popup');
      let $parent = $this.parents('.alp-product-item-xx-selector');
      let $product_id = $parent.attr('data-product-id');
      //
      let $target_wrapper = $parent.parents('.alp-section').find('.alp-combo-sale-select-product-main-wrapper-inner');
      $target_wrapper
        .find(`.alp-combo-sale-select-product-main:not(.active)`)
        .eq(0)
        .addClass('active')
        .find(`[data-product-id="${$product_id}"]`)
        .addClass('active');

      $popup.removeClass('active');
      let $target_active_length = $target_wrapper.find('.alp-combo-sale-select-product-main.active').length;
      if ($target_active_length >= 1) {
        $target_wrapper
          .parents('.alp-combo-sale-select-content')
          .find('.alp-combo-sale-select-bottom')
          .addClass('active');
      }
      if ($target_active_length >= 2) {
        $target_wrapper.addClass('active');
        $target_wrapper.parents('.alp-combo-sale-select-content').addClass('active');
        // $target_wrapper.parents('.alp-combo-sale-select-content').find(`[data-combo-gift]`).addClass('active');
        $target_wrapper
          .parents('.alp-combo-sale-select-content')
          .find('.alp-combo-sale-select-product-gift')
          .addClass('active');
      }
    });
    // remove product
    $('.alp-product-item-xx-select-remove').click(function () {
      let $this = $(this);
      let $parent = $this.parents('.alp-product-item-xx-select');
      let $target_wrapper = $parent.parents('.alp-section').find('.alp-combo-sale-select-product-main-wrapper-inner');
      $parent.removeClass('active');
      $parent.parents('.alp-combo-sale-select-product-main').removeClass('active');
      $target_wrapper.removeClass('active');
      $target_wrapper.parents('.alp-combo-sale-select-content').removeClass('active');
      $parent
        .parents('.alp-combo-sale-select-content')
        .find('.alp-combo-sale-select-product-gift')
        .removeClass('active');
      let $target_active_length = $target_wrapper.find('.alp-combo-sale-select-product-main.active').length;
      if ($target_active_length == 0) {
        $target_wrapper
          .parents('.alp-combo-sale-select-content')
          .find('.alp-combo-sale-select-bottom')
          .removeClass('active');
      }
    });
    // gift select trigger
    $('.alp-combo-sale-select-product-gift > div').click(function () {
      let $this = $(this);
      let $parent = $this.parent();
      if ($parent.hasClass('active')) {
        $this.addClass('active').siblings().removeClass('active');
        let $free_text = $this.attr('data-free-text');
        $('[data-combo-gift]').find('.final-price').text($free_text).addClass('active');
        let $coupon_code = $this.attr('data-coupon-code');
        navigator.clipboard
          .writeText($coupon_code)
          .then(() => {
            const notification = $this.find('.copyNotification');
            notification.stop().slideDown(300);
            setTimeout(() => {
              notification.stop().slideUp(200);
            }, 5000);
          })
          .catch((err) => {});
      }
    });
    //
    function calcPrice() {
      let $usd = '$';
      let $total_price = 0;
      let $total_original_price = 0;
      let $target_wrapper = $('.alp-combo-sale-select-content');
      let $active_main_products = $target_wrapper.find('.alp-combo-sale-select-product-main.active');
      let $active_gift_product = $target_wrapper.find('.alp-combo-sale-select-product-gift.active');
      let $additional_products = $target_wrapper.find('.alp-product-promotion-new-2-item-2');
      $active_main_products.each(function () {
        let $this = $(this);
        $total_price += Number(
          $this
            .find(`.alp-product-item-xx-select[data-product-id].active .price_with_variants_item.active`)
            .attr('data-price')
        );
        $total_original_price += Number(
          $this
            .find(`.alp-product-item-xx-select[data-product-id].active .price_with_variants_item.active`)
            .attr('data-original-price')
        );
      });
      $active_gift_product.each(function () {
        let $this = $(this);
        if ($this.children(`.active`).length > 0) {
          let $final_price = Number($this.children(`.active`).attr('data-price'));
          if ($final_price < 0) {
            $total_price = $total_price - Math.abs($final_price);
          } else {
            $total_price = $total_price + $final_price;
          }
          $total_original_price += Number($this.children(`.active`).attr('data-original-price'));
        }
      });
      $target_wrapper.find('.alp-combo-sale-select-line-item[data-combo-additional]').html('');
      $additional_products.each(function () {
        let $this = $(this);
        let $quantity_input = $this.find(`input.quantity__input[type=number]`);
        $total_price += Number($this.attr('data-price')) * Number($quantity_input.val());
        $total_original_price += Number($this.attr('data-original-price')) * Number($quantity_input.val());
        // append each item to line item data-combo-additional
        let $price = (Number($this.attr('data-price')) / 100) * Number($quantity_input.val());
        if (Number($quantity_input.val()) > 0) {
          $target_wrapper.find('.alp-combo-sale-select-line-item[data-combo-additional]').append(`
            <div class="alp-combo-sale-select-line-item-additional">
              <span>${$this
                .find('.alp-product-promotion-new-2-i-title-2 .promotion-new-item-title-text .headline__h6')
                .text()} x ${Number($quantity_input.val())}</span>
              <span class="final-price">${$usd}${$price.toFixed(2)}</span>
            </div>
          `);
        }
      });
      $total_original_price = $total_original_price / 100;
      $total_price = $total_price / 100;
      $target_wrapper
        .find('.alp-combo-sale-select-total-price')
        .find('.original-price')
        .html($usd + $total_original_price.toFixed(2));
      $target_wrapper
        .find('.alp-combo-sale-select-total-price')
        .find('.final-price')
        .html($usd + $total_price.toFixed(2));
    }
    setInterval(function () {
      calcPrice();
    }, 1000);

    //
    async function addToCartAndCheckout(button) {
      let $this = button ? button : $('.alp-combo-sale-select-checkout-button .alp-button');
      let $data = [];
      let $wrapper = $this.parents('.alp-combo-sale-select-content');
      $wrapper.find('.alp-combo-sale-select-product-main.active').each(function () {
        let $this = $(this);
        let $variant_id = $this.find(`[data-product-id].active`).attr('data-active-variant');
        $data.push({ id: $variant_id, quantity: 1 });
      });
      $wrapper.find('.alp-combo-sale-select-product-gift.active').each(function () {
        let $this = $(this);
        if ($this.find(`[data-product-id].active`).length > 0) {
          let $variant_id = $this.find(`[data-product-id].active`).attr('data-active-variant');
          $data.push({ id: $variant_id, quantity: 1 });
        }
      });
      $wrapper.find('.alp-combo-sale-select-additional-products-item').each(function () {
        let $this = $(this);
        let $variant_id = $this.find(`.alp-product-promotion-new-2-item-2`).attr('data-active-variant');
        let $quantity = Number($this.find(`input.quantity__input[type=number]`).val());
        if ($quantity > 0) {
          $data.push({ id: $variant_id, quantity: $quantity });
        }
      });
      console.log($data);
      $this.addClass('adding');
      await fetch(Shopify_Url + 'cart/clear.js', {
        method: 'POST',
      });
      await AlpFn.AddToCartMulti($data);
      $this.removeClass('adding');
      // apply coupon code
      //   let $coupon_code = $wrapper
      //     .find('.alp-combo-sale-select-product-gift.active > div.active')
      //     .attr('data-coupon-code');
      //   if ($coupon_code) {
      //     window.discountOnCartProApp.applyCode($coupon_code);
      //   }
      // refresh cart
      await AlpFn.refreshCart('[data-ajax-cart]');
      document.body.classList.add('cart-open');
      setTimeout(() => {
        $('[data-ajax-cart]').addClass('open');
        document.body.classList.add('noscroll');
      }, 50);
      // trigger checkout button
      //   $(`.alp-checkout-buttons .alp-button[type="submit"][value="Checkout"]`).trigger('click');
    }
    //
    $('.alp-combo-sale-select-checkout-button .alp-button').click(function () {
      addToCartAndCheckout($(this));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["alp-combo-sale-select"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    // popup open
    $('.alp-combo-sale-select-product-main-trigger').click(function () {
      let $this = $(this);
      let $popup = $this.parents('.alp-section').find('.alp-combo-sale-select-product-main-selector-popup');
      $popup.addClass('active');
    });
    // popup close
    $(
      '.alp-combo-sale-select-product-main-selector-inner-header-close, .alp-combo-sale-select-product-main-selector-popup-bg'
    ).click(function () {
      let $this = $(this);
      let $popup = $this.parents('.alp-combo-sale-select-product-main-selector-popup');
      $popup.removeClass('active');
    });
    //
    $('.alp-product-item-xx-selector-add').click(function () {
      let $this = $(this);
      let $popup = $this.parents('.alp-combo-sale-select-product-main-selector-popup');
      let $parent = $this.parents('.alp-product-item-xx-selector');
      let $product_id = $parent.attr('data-product-id');
      //
      let $target_wrapper = $parent.parents('.alp-section').find('.alp-combo-sale-select-product-main-wrapper-inner');
      $target_wrapper
        .find(`.alp-combo-sale-select-product-main:not(.active)`)
        .eq(0)
        .addClass('active')
        .find(`[data-product-id="${$product_id}"]`)
        .addClass('active');

      $popup.removeClass('active');
      let $target_active_length = $target_wrapper.find('.alp-combo-sale-select-product-main.active').length;
      if ($target_active_length >= 1) {
        $target_wrapper
          .parents('.alp-combo-sale-select-content')
          .find('.alp-combo-sale-select-bottom')
          .addClass('active');
      }
      if ($target_active_length >= 2) {
        $target_wrapper.addClass('active');
        $target_wrapper.parents('.alp-combo-sale-select-content').addClass('active');
        // $target_wrapper.parents('.alp-combo-sale-select-content').find(`[data-combo-gift]`).addClass('active');
        $target_wrapper
          .parents('.alp-combo-sale-select-content')
          .find('.alp-combo-sale-select-product-gift')
          .addClass('active');
      }
    });
    // remove product
    $('.alp-product-item-xx-select-remove').click(function () {
      let $this = $(this);
      let $parent = $this.parents('.alp-product-item-xx-select');
      let $target_wrapper = $parent.parents('.alp-section').find('.alp-combo-sale-select-product-main-wrapper-inner');
      $parent.removeClass('active');
      $parent.parents('.alp-combo-sale-select-product-main').removeClass('active');
      $target_wrapper.removeClass('active');
      $target_wrapper.parents('.alp-combo-sale-select-content').removeClass('active');
      $parent
        .parents('.alp-combo-sale-select-content')
        .find('.alp-combo-sale-select-product-gift')
        .removeClass('active');
      let $target_active_length = $target_wrapper.find('.alp-combo-sale-select-product-main.active').length;
      if ($target_active_length == 0) {
        $target_wrapper
          .parents('.alp-combo-sale-select-content')
          .find('.alp-combo-sale-select-bottom')
          .removeClass('active');
      }
    });
    //
    function calcPrice() {
      let $usd = '$';
      let $total_price = 0;
      let $total_original_price = 0;
      let $target_wrapper = $('.alp-combo-sale-select-content');
      let $active_main_products = $target_wrapper.find('.alp-combo-sale-select-product-main.active');
      let $active_gift_product = $target_wrapper.find('.alp-combo-sale-select-product-gift.active');
      let $additional_products = $target_wrapper.find('.alp-product-promotion-new-2-item-2');
      $active_main_products.each(function () {
        let $this = $(this);
        $total_price += Number(
          $this
            .find(`.alp-product-item-xx-select[data-product-id].active .price_with_variants_item.active`)
            .attr('data-price')
        );
        $total_original_price += Number(
          $this
            .find(`.alp-product-item-xx-select[data-product-id].active .price_with_variants_item.active`)
            .attr('data-original-price')
        );
      });
      $active_gift_product.each(function () {
        let $this = $(this);
        $total_price += Number($this.find(`.alp-product-item-sale-gift-2.active`).attr('data-price'));
        $total_original_price += Number($this.find(`.alp-product-item-sale-gift-2.active`).attr('data-original-price'));
      });
      $target_wrapper.find('.alp-combo-sale-select-line-item[data-combo-additional]').html('');
      $additional_products.each(function () {
        let $this = $(this);
        let $quantity_input = $this.find(`input.quantity__input[type=number]`);
        $total_price += Number($this.attr('data-price')) * Number($quantity_input.val());
        $total_original_price += Number($this.attr('data-original-price')) * Number($quantity_input.val());
        // append each item to line item data-combo-additional
        let $price = (Number($this.attr('data-price')) / 100) * Number($quantity_input.val());
        if (Number($quantity_input.val()) > 0) {
          $target_wrapper.find('.alp-combo-sale-select-line-item[data-combo-additional]').append(`
            <div class="alp-combo-sale-select-line-item-additional">
              <span>${$this
                .find('.alp-product-promotion-new-2-i-title-2 .promotion-new-item-title-text .headline__h6')
                .text()} x ${Number($quantity_input.val())}</span>
              <span class="final-price">${$usd}${$price.toFixed(2)}</span>
            </div>
          `);
        }
      });
      $total_original_price = $total_original_price / 100;
      $total_price = $total_price / 100;
      $target_wrapper
        .find('.alp-combo-sale-select-total-price')
        .find('.original-price')
        .html($usd + $total_original_price.toFixed(2));
      $target_wrapper
        .find('.alp-combo-sale-select-total-price')
        .find('.final-price')
        .html($usd + $total_price.toFixed(2));
    }
    setInterval(function () {
      calcPrice();
    }, 1000);

    //
    async function addToCartAndCheckout(button) {
      let $this = button ? button : $('.alp-combo-sale-select-checkout-button .alp-button');
      let $data = [];
      let $wrapper = $this.parents('.alp-combo-sale-select-content');
      $wrapper.find('.alp-combo-sale-select-product-main.active').each(function () {
        let $this = $(this);
        let $variant_id = $this.find(`[data-product-id].active`).attr('data-active-variant');
        $data.push({ id: $variant_id, quantity: 1 });
      });
      $wrapper.find('.alp-combo-sale-select-product-gift.active').each(function () {
        let $this = $(this);
        let $variant_id = $this.find(`[data-product-id].active`).attr('data-active-variant');
        $data.push({ id: $variant_id, quantity: 1 });
      });
      $wrapper.find('.alp-combo-sale-select-additional-products-item').each(function () {
        let $this = $(this);
        let $variant_id = $this.find(`.alp-product-promotion-new-2-item-2`).attr('data-active-variant');
        let $quantity = Number($this.find(`input.quantity__input[type=number]`).val());
        $data.push({ id: $variant_id, quantity: $quantity });
      });
      console.log($data);
      $this.addClass('adding');
      await fetch(Shopify_Url + 'cart/clear.js', {
        method: 'POST',
      });
      await AlpFn.AddToCartMulti($data);
      $this.removeClass('adding');
      // trigger checkout button
      $(`.alp-checkout-buttons .alp-button[type="submit"][value="Checkout"]`).trigger('click');
    }
    //
    $('.alp-combo-sale-select-checkout-button .alp-button').click(function () {
      addToCartAndCheckout($(this));
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ap-announcebar-v1"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', () => {
    // init ap-announcebar-v1-swiper swiper
    new Swiper('.ap-announcebar-v1-swiper', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      //   autoHeight: true,
      speed: 800,
      autoplay: {
        delay: 6000,
        disableOnInteraction: true,
      },
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axx-global-compare-full"] && !Shopify.designMode) return;
  try {
    
  window.addEventListener('load', () => {
    class GlobalCompare {
      // checkbox : .global-compare-checkbox with [data-product-id]
      // trigger : [data-global-compare-open] with [data-global-compare-open=' product.id ']
      // options selector : .global-compare-selector
      // options : .global-compare-options with [data-product-id]
      // floating tab: .global-compare-floating-tab

      constructor() {
        // 存储事件处理函数
        this.checkboxs = [];
        this.eventListeners = new Map();
        this.compareParent = document.querySelector('.global-compare');
        this.floatingTab = document.querySelector('.global-compare-floating-tab');
        this.init();
      }

      init() {
        this.removePreloadProducts();
        this.triggerSelectOpen();
        this.updateSelectedProduct();
        this.setSameHeightForItems();
        this.hanldeSelectorChange();
        this.findTheItemsDiff();
        this.triggerOpen();
        this.triggerCompareCheckboxInit();
        this.updateFlotingTabStatus(this.getCookie());
        this.clickFlotingTab();
        window.addEventListener('resize', () => this.setSameHeightForItems());
        window.addEventListener('CompareTrigger', () => this.checkboxEventUpdate());
        this.compareParent.querySelector('.global-compare-diff-trigger').addEventListener('click', () => {
          this.compareParent.classList.toggle('show_diff');
          this.setSameHeightForItems();
        });
      }

      triggerSelectOpen() {
        const globalCompareSelector = document.querySelector('.global-compare-selector span');
        const globalCompareOptions = globalCompareSelector
          .closest('.global-compare-selector')
          .querySelector('.global-compare-options');
        globalCompareSelector.addEventListener('click', () => {
          globalCompareOptions.classList.toggle('hidden');
        });
        document.addEventListener('click', (e) => {
          if (!e.target.closest('.global-compare-selector')) {
            globalCompareOptions.classList.add('hidden');
          }
        });
      }

      updateSelectedProduct() {
        const options = document.querySelectorAll('.global-compare-option');
        options.forEach((option) => {
          option.classList.remove('selected');
        });
        options.forEach((option) => {
          const productId = option.dataset.productId;
          const productEl = this.compareParent.querySelector(
            `.products-new-compare-wrapper [data-product-id="${productId}"]`
          );
          if (productEl) option.classList.add('selected');
        });
      }

      setSameHeightForItems() {
        const rows = document.querySelectorAll(
          '.products-new-compare-wrapper .product-new-compare-i .axx_compare_spec_list'
        );
        const items = rows[0]?.querySelectorAll('.axx_compare_spec_list_item') || [];
        // 重置高度
        rows.forEach((row) => {
          row.querySelectorAll('.axx_compare_spec_list_item').forEach((item) => {
            item.style.setProperty('--height', 'auto');
          });
        });
        // 设置规格高度
        items.forEach((_, index) => {
          let maxHeight = 0;
          rows.forEach((row) => {
            const item = row.querySelectorAll('.axx_compare_spec_list_item')[index];
            maxHeight = Math.max(maxHeight, item.offsetHeight);
          });
          rows.forEach((row) => {
            const item = row.querySelectorAll('.axx_compare_spec_list_item')[index];
            item.style.setProperty('--height', `${maxHeight}px`);
          });
        });
        // 设置图片高度
        const imageWrappers = document.querySelectorAll(
          '.products-new-compare-wrapper .product-new-compare-i .axx-images-with-swatch'
        );
        const maxImageHeight = Math.max(...[...imageWrappers].map((img) => img.offsetHeight), 0);
        imageWrappers.forEach((img) => img.style.setProperty('--height', `${maxImageHeight}px`));
      }

      hanldeSelectorChange() {
        const options = document.querySelectorAll('.global-compare-option');
        options.forEach((option) => {
          option.addEventListener('click', () => {
            const productId = option.dataset.productId;
            option.classList.toggle('selected');
            option.classList.contains('selected') ? this.addProduct(productId) : this.removeProduct(productId);
          });
        });
      }

      removePreloadProducts() {
        this.compareParent
          .querySelectorAll('.products-new-compare-wrapper .product-new-compare-item[data-product-id]')
          .forEach((el) => el.remove());
      }

      async addProduct(ids) {
        // 处理多id输入并去重
        const idArray = Array.isArray(ids)
          ? ids
          : ids
              .toString()
              .split(',')
              .filter((id) => id.trim() !== '');
        const uniqueIds = [...new Set(idArray)];
        const fetchUrl = this.compareParent.dataset.fetchUrl;
        this.compareParent.classList.add('loading');
        // compare ids and the existing products `.product-new-compare-item[data-product-id="${id}"]`
        const existingProducts = this.compareParent.querySelectorAll('.product-new-compare-item[data-product-id]');
        const existingIds = [...existingProducts].map((el) => el.dataset.productId);
        const newIds = uniqueIds.filter((id) => !existingIds.includes(id));
        if (newIds.length === 0) {
          this.compareParent.classList.remove('loading');
          this.compareParent.classList.remove('first-load');
          return;
        }
        // continue to add products
        try {
          const response = await fetch(fetchUrl);
          const responseText = await response.text();
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const sourceParents = html.querySelectorAll('.products-new-compare-wrapper');
          const targetWrappers = this.compareParent.querySelectorAll('.products-new-compare-wrapper');
          // 遍历每个唯一id添加产品
          uniqueIds.forEach((id) => {
            sourceParents.forEach((sourceEl, index) => {
              const targetEl = targetWrappers[index];
              if (!targetEl) return;
              const exitProductEl = targetEl.querySelector(`.product-new-compare-item[data-product-id="${id}"]`);
              // if (exitProductEl) exitProductEl.remove();
              if (exitProductEl) return;
              const productEl = sourceEl.querySelector(`.product-new-compare-item[data-product-id="${id}"]`);
              if (productEl) targetEl.appendChild(productEl);
              const removeEl = productEl.querySelector('.product-compare-remove');
              if (removeEl) this.handleRemoveProductTrigger(removeEl);
            });
          });
        } finally {
          this.findTheItemsDiff();
          this.updateSelectedProduct();
          this.setSameHeightForItems();
          if (window.axxVariantsSwatch) window.axxVariantsSwatch.update();
          this.compareParent.classList.remove('loading');
          this.compareParent.classList.remove('first-load');
          this.setCookie();
          this.updateCheckboxStatus();
        }
      }

      removeProduct(id) {
        this.compareParent
          .querySelectorAll(`.products-new-compare-wrapper [data-product-id="${id}"]`)
          .forEach((el) => el.remove());
        this.findTheItemsDiff();
        this.updateSelectedProduct();
        this.setSameHeightForItems();
        this.setCookie();
        this.updateCheckboxStatus();
      }

      handleRemoveProductTrigger(el) {
        el.addEventListener('click', (e) => {
          e.preventDefault();
          const parent = el.closest('.product-new-compare-item');
          const productId = parent.dataset.productId;
          this.removeProduct(productId);
        });
      }

      setCookie() {
        const uniqueIds = [];
        this.compareParent
          .querySelectorAll('.global-compare-option.selected')
          .forEach((el) => uniqueIds.push(el.dataset.productId));
        // 存储id到cookie（30天过期）
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `selectedIds=${uniqueIds.join(',')}; expires=${expires}; path=/`;
        this.updateFlotingTabStatus(`${uniqueIds.join(',')}`);
      }

      getCookie() {
        // let presetIds = this.compareParent.dataset.presetProducts;
        const cookieValue =
          document.cookie
            .split('; ')
            .find((row) => row.startsWith('selectedIds='))
            ?.split('=')[1] || '';
        if (cookieValue) {
          return cookieValue;
        }
      }

      addIdToCookie(id) {
        let ids = this.getCookie();
        if (!ids) {
          ids = id;
        } else {
          ids = `${ids},${id}`;
        }
        const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `selectedIds=${ids}; expires=${expires}; path=/`;
        this.updateFlotingTabStatus(ids);
      }

      removeIdFromCookie(id) {
        let ids = this.getCookie();
        if (ids) {
          ids = ids
            .split(',')
            .filter((i) => i !== id)
            .join(',');
          const expires = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toUTCString();
          document.cookie = `selectedIds=${ids}; expires=${expires}; path=/`;
          this.updateFlotingTabStatus(ids);
        }
      }

      findTheItemsDiff() {
        document
          .querySelectorAll(
            '.products-new-compare-wrapper.has-compare-data .axx_compare_spec_list .axx_compare_spec_list_item'
          )
          .forEach((item) => {
            item.classList.remove('diff');
          });
        const allRows = document.querySelectorAll(
          '.products-new-compare-wrapper.has-compare-data .axx_compare_spec_list'
        );
        const rows = document.querySelectorAll(
          '.products-new-compare-wrapper.has-compare-data [data-product-id] .axx_compare_spec_list'
        );
        const firstRowItems = rows[0]?.querySelectorAll('.axx_compare_spec_list_item') || [];
        firstRowItems.forEach((_, index) => {
          const values = [...rows].map(
            (row) => row.querySelectorAll('.axx_compare_spec_list_item')[index]?.querySelector('.axcp-desc').textContent
          );
          const hasDiff = new Set(values).size > 1;
          if (hasDiff) {
            allRows.forEach((row) => {
              row.querySelectorAll('.axx_compare_spec_list_item')[index].classList.add('diff');
            });
          }
        });
      }

      triggerCompareCheckboxInit() {
        this.checkboxs = document.querySelectorAll('.global-compare-checkbox');
        if (this.checkboxs.length > 0) {
          this.updateCheckboxStatus();
          this.checkboxs.forEach((checkbox) => {
            const handler = (e) => this.checkboxToggle(checkbox);
            this.eventListeners.set(checkbox, handler);
            checkbox.addEventListener('click', handler);
          });
        }
      }

      checkboxEventUpdate() {
        this.checkboxs.forEach((checkbox) => {
          const handler = this.eventListeners.get(checkbox);
          if (handler) {
            checkbox.removeEventListener('click', handler);
          }
        });
        this.triggerCompareCheckboxInit();
      }

      checkboxToggle(checkbox) {
        const productId = checkbox.dataset.productId;
        if (checkbox.classList.contains('checked')) {
          checkbox.classList.remove('checked');
          this.removeIdFromCookie(productId);
        } else {
          this.addIdToCookie(productId);
        }
        this.updateCheckboxStatus();
      }

      updateCheckboxStatus() {
        let ids = this.getCookie();
        // remove class
        this.checkboxs.forEach((checkbox) => {
          checkbox.classList.remove('checked');
        });
        // update classlist
        if (ids) {
          ids.split(',').forEach((id) => {
            this.checkboxs.forEach((checkbox) => {
              let checkboxId = parseInt(checkbox.dataset.productId);
              if (checkboxId == id) {
                checkbox.classList.add('checked');
              }
            });
          });
          this.updateFlotingTabStatus(ids);
        }
      }

      updateFlotingTabStatus(selectedIds) {
        let floatingTab = this.floatingTab;
        if (!floatingTab) {
          return;
        }
        if (selectedIds) {
          const selectedIdsArray = selectedIds.split(',');
          const selectedIdsCount = selectedIdsArray.length;
          if (selectedIdsCount > 0) {
            floatingTab.classList.add('show');
          } else {
            floatingTab.classList.remove('show');
          }
          floatingTab.querySelector('.compare-products-count').textContent = selectedIdsCount;
        } else {
          floatingTab.classList.remove('show');
        }
      }

      clickFlotingTab() {
        let floatingTab = this.floatingTab;
        if (!floatingTab) {
          return;
        }
        floatingTab.addEventListener('click', (e) => {
          e.preventDefault();
          let ids = this.getCookie() ? this.getCookie() : presetIds;
          if (ids) {
            this.addProduct(ids);
            this.compareParent.classList.remove('hidden');
          }
        });
      }

      triggerOpen() {
        const triggers = document.querySelectorAll('[data-global-compare-open]');
        triggers.forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            const productId = el.dataset.globalCompareOpen || 'null';
            const productEl = this.compareParent.querySelector(
              `.product-new-compare-item[data-product-id="${productId}"]`
            );
            if (productEl) {
              this.compareParent.classList.remove('hidden');
              this.setSameHeightForItems();
            } else {
              let presetIds = this.compareParent.dataset.presetProducts;
              let ids = this.getCookie() ? this.getCookie() : presetIds;
              if (!ids) {
                ids = productId;
              } else {
                ids = `${ids},${productId}`;
              }
              this.addProduct(ids);
              this.compareParent.classList.remove('hidden');
            }
          });
        });
        const closeTriggers = this.compareParent.querySelectorAll('.global-compare-close, .global-compare-overlay');
        closeTriggers.forEach((el) => {
          el.addEventListener('click', (e) => {
            e.preventDefault();
            this.compareParent.classList.add('hidden');
          });
        });
      }
    }

    window.axxGlobalCompare = new GlobalCompare();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["axx-page-compare"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
